<template>
  <div v-show="isShow">
    <config-item>
      <div class="flex_box">
        <div class="label_box">{{ label }}</div>
        <el-select
          style="flex-grow: 1; width: unset"
          size="mini"
          v-model="value.status"
          placeholder="请选择"
          @change="clickItem"
        >
          <el-option
            v-for="item in tagList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </config-item>

    <config-item label="图片" v-show="value.status == 'image'">
      <div class="flex flex-nowrap row-right">
        <SchemaUpload label="" v-model="value.url" />
      </div>
    </config-item>

    <config-item label="图片缩放" v-show="value.status == 'image'">
      <div class="flex flex-nowrap row-right">
        <el-select
          v-model="value.zoom"
          placeholder="请选择"
          size="small"
          style="width: 75%"
        >
          <el-option
            v-for="item in list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </config-item>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
export default {
  name: "SchemaSelectTitleMode",
  mixins: [schemaMixin],
  inject: ["mode"],
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isShow: {
      default: true,
    },
  },
  data() {
    return {
      tagList: [
        { label: "无修饰", value: "hide" },
        { label: "左边框", value: "left" },
        { label: "下划线", value: "bottom" },
        { label: "图片", value: "image" },
      ],
      list: [
        { label: "填充", value: "cover" },
        { label: "等比例", value: "contain" },
        { label: "平铺", value: "repeat" },
        { label: "拉伸", value: "stretch" },
        { label: "原图", value: "artwork" },
      ],
    };
  },
  methods: {
    clickItem() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.flex_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.label_box {
  font-size: 14px;
  width: 95px;
  color: #969799;
  margin-right: 10px;
}
</style>
